import { Image, Container, Row, Col } from 'react-bootstrap';
import Img from '../Img/Towel/bath-towel-Banner.jpg';
import CircularGallery from './CircularAccGallery';
import "./Services.css";

function Accessories() {
    return (
        <>
            <Image className="fade-in responsive-img" src={Img} height={500} width="100%" fluid />
            <Container>
                <Row>
                    <Col>
                        <h1 className='text-center my-4 text-decoration-underline'><strong>TOWELS</strong></h1>
                        <p style={{ fontSize: '20px' }} className='justify-text'>Exquisite craftsmanship is woven into every towel we offer. Our collection showcases premium materials, from plush cottons to sustainable blends, designed for both comfort and style. We curate and source from artisans and brands who stay attuned to the latest trends in home fashion, introducing fresh designs and color stories with every season.</p>
                    </Col>
                </Row>
            </Container>
            <div style={{ height: '600px', position: 'relative' }}>
                <CircularGallery bend={3} borderRadius={0.05} scrollEase={0.02} />
            </div>
        </>
    )
}

export default Accessories